/* Dunorm animated review highlight.
   Paints each <mark class="dn-hl"> left-to-right when its card scrolls into view.
   The animation itself is CSS (background-size); this only decides WHEN to start it,
   and only once per element so it never re-runs while scrolling up and down. */
(function () {
  if (window.__dnHighlight) return;
  window.__dnHighlight = true;

  function start() {
    var marks = document.querySelectorAll('.dn-hl');
    if (!marks.length) return;

    if (!('IntersectionObserver' in window)) {
      marks.forEach(function (m) { m.classList.add('is-lit'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        /* light every mark inside the same quote together so the delays read as one sweep */
        var quote = e.target.closest('.q') || e.target;
        quote.querySelectorAll('.dn-hl').forEach(function (m) { m.classList.add('is-lit'); });
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.35 });

    marks.forEach(function (m) { io.observe(m); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* the cart drawer and Dawn section re-renders can inject new quotes */
  document.addEventListener('dn:cart:updated', start);
})();
